import React, { useState } from "react";
import OtpInput from "react18-input-otp";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Button,
  NotificationModal,
  Typography,
  RegistrationModal,
} from "components";
import AuthHeader from "./AuthHeader";
import AuthFooter from "./AuthFooter";
import { routes } from "routes/apiRoutes";
import { isSuccessResponse } from "utils/helper";
import makeRequest from "services/makeRequest";
import { ROUTES, pocketMoniUrl } from "routes/routePaths";
import resetImage from "assets/images/reset-image.png";
import pmLogo from "assets/images/pocketmoni-logo.png";
import otpImage from "assets/images/otp-sent.png";
import "./style.scss";

const OTPPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [otp, setOtp] = useState("");
  const [sendingOTP, setSendingOTP] = useState(false);

  const [state, setState] = useState({
    error: false,
    loading: false,
  });

  const [showModal, setShowModal] = useState(false);

  const email = location?.state?.email;

  const resendOTP = async () => {
    setSendingOTP(true);
    try {
      const { data } = await makeRequest("post", routes.forgotPassword(email));
      if (isSuccessResponse(data)) {
        setOtp("");
        setShowModal(true);
      }
    } catch (error) {
    } finally {
      setSendingOTP(false);
    }
  };

  const verifyOTP = async () => {
    setState({
      error: false,
      loading: true,
    });

    try {
      const { data } = await makeRequest("post", routes.validateOTP(), {
        email,
        otp,
      });
      if (isSuccessResponse(data)) {
        setState({ ...state, loading: false });
        navigate(ROUTES.passwordSet, {
          state: { reset: true, passKey: data.data.passkey },
        });
      } else {
        setState({
          error: true,
          loading: false,
        });
      }
    } catch (error) {
      console.log(error);
      setState({ ...state, loading: false });
    }
  };

  return (
    <div className="row m-0 auth-container">
      <div className="auth-header-container">
        <AuthHeader />
      </div>

      <div className="col-12 col-xl-6 p-0 auth-form-container">
        <div className="login-form">
          <div className="auth-intro">
            <div className="mb-4 d-xl-none">
              <a href={pocketMoniUrl} target="_blank" rel="noopener noreferrer">
                <img src={pmLogo} width="150" alt="PocketMoni" />
              </a>{" "}
            </div>
            <Typography component="h3" variant="heading3" state="primary">
              OTP Verification
            </Typography>
            <Typography variant="body3" state="primary">
              Please enter the verification code sent to your email address here
            </Typography>
          </div>
          {state.error && (
            <Typography
              variant="body4"
              className="text-center mt-2"
              state="danger"
            >
              Invalid OTP! Please check and try again!
            </Typography>
          )}

          <div style={{ margin: "2rem 0" }}>
            <OtpInput
              value={otp}
              inputStyle="otp-input"
              onChange={(val) => setOtp(val)}
              numInputs={6}
              shouldAutoFocus
              isInputNum
            />
          </div>

          <Button
            label="Verify OTP"
            disabled={otp.length < 6 || sendingOTP}
            fullWidth
            onClick={verifyOTP}
          />

          {email && (
            <div className="mt-3">
              <Typography component="span" variant="body3">
                Didn't get OTP?
              </Typography>{" "}
              <Typography
                component="span"
                state="primary"
                className="text-underline cursor-pointer"
                onClick={resendOTP}
                variant="body4"
              >
                Click to resend
              </Typography>{" "}
              {/* <Typography variant="caption1" state="grey" className={"mt-1"}>
                Alternatively, You can dial *389*0# on your registered PM Number
                to get your OTP.
              </Typography> */}
            </div>
          )}
        </div>
        <RegistrationModal
          showModal={state.loading}
          modalContentMapper="validating"
          validationText="OTP"
        />
        <NotificationModal
          showModal={showModal}
          onClose={() => setShowModal(false)}
          image={<img src={otpImage} alt="" width="180" />}
          headerText="Check your mailbox!"
          bodyText="Kindly check your mailbox, an OTP has just been sent to your email address for you to reset your password."
        />
        <div className="mt-4">
          <AuthFooter />
        </div>
      </div>

      <div className="d-none d-xl-block col-xl-6 p-0">
        <img src={resetImage} width="100%" alt="Log In" />
      </div>
    </div>
  );
};

export default OTPPage;
